module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/2.9.3-189.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/2.9.3.md
// module id = 634
// module chunks = 476